import {
  BASE_CITIES,
  LocationOption,
  NEW_UK_CITIES,
  Country,
  locationCountries,
} from "../constants/locations";

import { partition } from "./collections";

import { Location } from "@otta/search/schema";

// Function to get all available cities based on feature flag state
export function getAvailableCities(
  includeNewUkCities: boolean
): LocationOption[] {
  const cities = [...BASE_CITIES, ...NEW_UK_CITIES];

  if (includeNewUkCities) {
    cities.push(...NEW_UK_CITIES);
  }

  // Sort alphabetically by label
  return cities.sort((a, b) => a.label.localeCompare(b.label));
}

export const REMOTE_LOCATIONS_WITH_LABELS: LocationOption[] = [
  { label: "Remote (within the UK)", value: Location.RemoteUk },
  { label: "Remote (within the US)", value: Location.RemoteUs },
  { label: "Remote (within the EU)", value: Location.RemoteEurope },
  { label: "Remote (within France)", value: Location.RemoteFrance },
  { label: "Remote (within Germany)", value: Location.RemoteGermany },
  { label: "Remote (within Ireland)", value: Location.RemoteIreland },
  {
    label: "Remote (within the Netherlands)",
    value: Location.RemoteNetherlands,
  },
  { label: "Remote (within Spain)", value: Location.RemoteSpain },
  { label: "Remote (within Canada)", value: Location.RemoteCanada },
];

export const LOCATION_NAME: Partial<Record<Location, string>> = {
  [Location.Amsterdam]: "Amsterdam",
  [Location.AustinUs]: "Austin",
  [Location.Barcelona]: "Barcelona",
  [Location.Berlin]: "Berlin",
  [Location.Birmingham]: "Birmingham",
  [Location.BostonUs]: "Boston",
  [Location.Bristol]: "Bristol",
  [Location.Cambridge]: "Cambridge",
  [Location.Cardiff]: "Cardiff",
  [Location.ChicagoUs]: "Chicago",
  [Location.DenverUs]: "Denver",
  [Location.Dublin]: "Dublin",
  [Location.Edinburgh]: "Edinburgh",
  [Location.Glasgow]: "Glasgow",
  [Location.Leeds]: "Leeds",
  [Location.London]: "London",
  [Location.LosAngelesUs]: "Los Angeles",
  [Location.Manchester]: "Manchester",
  [Location.MiamiUs]: "Miami",
  [Location.NewYorkUs]: "New York",
  [Location.Nottingham]: "Nottingham",
  [Location.Oxford]: "Oxford",
  [Location.Paris]: "Paris",
  [Location.SanFranciscoBayAreaUs]: "San Francisco Bay Area",
  [Location.Toronto]: "Toronto",
  [Location.Vancouver]: "Vancouver",
  [Location.RemoteUk]: "UK",
  [Location.RemoteUs]: "US",
  [Location.RemoteCanada]: "Canada",
  [Location.RemoteEurope]: "Anywhere else within the EU",
  [Location.RemoteFrance]: "France",
  [Location.RemoteGermany]: "Germany",
  [Location.RemoteIreland]: "Ireland",
  [Location.RemoteNetherlands]: "Netherlands",
  [Location.RemoteSpain]: "Spain",
};

export const REMOTE_LOCATIONS = [
  Location.RemoteUk,
  Location.RemoteUs,
  Location.RemoteEurope,
  Location.RemoteFrance,
  Location.RemoteGermany,
  Location.RemoteIreland,
  Location.RemoteNetherlands,
  Location.RemoteSpain,
  Location.RemoteCanada,
];

/**
 * Apply proximity-based ordering within each group
 */
export const sortByProximity = (
  locations: Location[],
  userCountry: Country | undefined
) => {
  if (!userCountry) return locations;

  const [international, nearby] = partition(locations)(
    loc => locationCountries[loc] === userCountry
  );

  return [...nearby, ...international];
};

export const sortByLondonFirst = (locations: Location[]) => {
  const [international, nearby] = partition(locations)(
    loc => loc === Location.London
  );

  return [...nearby, ...international];
};
